// lib/config.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.incidentclear.dev';
const CLIENT_CODE = process.env.REACT_APP_CLIENT_CODE;

if (!CLIENT_CODE) {
  console.error('REACT_APP_CLIENT_CODE is not defined in environment variables');
}

export const API_ENDPOINTS = {
  ORGANIZATION_SUMMARY: `${API_BASE_URL}/v2/accounts/${CLIENT_CODE}/summary`,
  SURVEYS: `${API_BASE_URL}/v2/surveys`,
};

export const RECAPTCHA_CONFIG = {
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  ACTION: 'motorist_survey',
};

export { CLIENT_CODE };